export default function PodcastWidget(){
  return (
    <div>
      <div className="mt-8">
        <iframe style={{"borderRadius":"12px"}} src="https://open.spotify.com/embed/show/6Ryzytf0Kf2jq4Vpz9RPWL?utm_source=generator&theme=0" width="100%" height="200" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" title="soenglish podcast"></iframe>
      </div>
    </div>
  )
}